import React, { useCallback, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import LandingPage from './LandingPage.js';
import reportWebVitals from './reportWebVitals.js';

const AppBoot = () => {
  const [isLoading, setIsLoading] = useState(true);
  const finishLoading = useCallback(() => setIsLoading(false), []);

  if (isLoading) {
    return <LandingPage onComplete={finishLoading} />;
  }

  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppBoot />
  </React.StrictMode>
);

reportWebVitals();
